import { Attribute, AttributeDefinition } from '../index';

export const singularAttribute = (fieldDefinition: AttributeDefinition): Attribute => ({
  pattern: fieldDefinition.pattern,
  valueAttribute: fieldDefinition.valueAttribute,
  fieldIndices: [],
});
